export default function offerParamsOptionsResolver({ offer, offerSettings, itemSettings, on }) {
    return {
        bind: {
            offer,
            offerSettings,
            itemSettings,
        },
        on: {
            'change-offer': on.changeOffer,
            'load-grouped-offers': on.loadGroupedOffers,
        },
    };
}
